import React, { ReactNode } from "react";

interface CompanyProfileCardProps {
  children: ReactNode;
  className?: string;
}

export const CompanyProfileCard = ({
  children,
  className = "",
}: CompanyProfileCardProps) => (
  <section
    className={`rounded-[6px] border-2 border-[#002959] bg-[linear-gradient(155deg,#1b4b86_0%,#002959_100%)] px-[20px] pb-[25px] pt-[15px] shadow-[4px_4px_4px_rgba(0,0,0,0.15)] sm:px-[30px] sm:pb-[30px] sm:pt-[20px] ${className}`}
  >
    {children}
  </section>
);

export const CompanyProfileCardTitle = ({
  children,
  action,
}: {
  children: ReactNode;
  /** Optional content rendered right-aligned in the title row (e.g. update date, link). */
  action?: ReactNode;
}) => (
  <div className="flex min-h-[55px] items-center gap-[15px] border-b border-white/50 py-[10px]">
    <div className="w-[4px] self-stretch rounded-[2px] bg-[#d4f754]" />
    <h2 className="font-['Noto_Sans_JP'] text-[20px] font-bold leading-[1.6] text-white sm:text-[22px]">
      {children}
    </h2>
    {action != null && <div className="ml-auto shrink-0">{action}</div>}
  </div>
);
